import React from 'react';
import { cn } from '../../../../lib/utils';

/**
 * FormTextarea - Atomic component for form textarea inputs
 * @param {Object} props
 * @param {boolean} props.error - Whether the textarea has an error
 * @param {string} props.className - Additional CSS classes
 * @param {React.Ref} ref - Forwarded ref
 */
export const FormTextarea = React.forwardRef(({ error = false, variant = 'default', className = '', ...props }, ref) => {
    const variants = {
        default: 'rounded-xl',
        box: 'rounded-md',
    };

    const baseClasses = 'w-full px-3 py-2 border bg-white shadow-sm text-base placeholder:text-[rgba(179,179,179,1)] focus:outline-none focus:ring-2';
    const errorClasses = error
        ? 'border-red-500 focus:ring-red-500'
        : 'border-[rgba(217,217,217,1)] focus:ring-red-400';

    return (
        <textarea
            ref={ref}
            className={cn(baseClasses, variants[variant] || variants.default, errorClasses, className)}
            {...props}
        />
    );
});

FormTextarea.displayName = 'FormTextarea';

export default FormTextarea;
